function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { floral, useMultiStyleConfig } from "@thebouqs/system";
export var Overlay = _ref => {
  var {
    color,
    onClick,
    testid,
    alignTo
  } = _ref;
  var styles = useMultiStyleConfig("Overlay", {
    color
  });
  var styledOverlayProps = {
    zIndex: "overlay",
    width: "100vw",
    height: "100%",
    position: "fixed",
    top: 0,
    [alignTo != null ? alignTo : 'left']: 0
  };
  return /*#__PURE__*/React.createElement(floral.div, _extends({
    onClick: onClick,
    sx: styles
  }, styledOverlayProps, {
    "data-testid": "overlay-" + testid
  }));
};
//# sourceMappingURL=Overlay.js.map